module.exports = __webpack_public_path__ + "img/flag_id.d916cdfb.jpg";